// extracted by mini-css-extract-plugin
export default {"logo":"future_uChjcU7hKYQN","header":"future_A2as5By83kzI"};